import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_3 = { class: "table-responsive p-0" }
const _hoisted_4 = { class: "table align-items-center mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Modelo"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }, "Capacidade"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Operação"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" })
  ])
], -1)
const _hoisted_6 = { class: "d-flex px-2 py-1" }
const _hoisted_7 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_8 = { class: "mb-0 text-sm" }
const _hoisted_9 = { class: "text-xs text-secondary mb-0" }
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_12 = { class: "align-middle text-xxs" }
const _hoisted_13 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_14 = { class: "align-middle text-center text-sm" }
const _hoisted_15 = { class: "form-check form-switch" }
const _hoisted_16 = ["onChange", "onUpdate:modelValue"]
const _hoisted_17 = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user-edit text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rows, (produto) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h6", _hoisted_8, _toDisplayString(produto.modelo), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(produto.marca), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(produto.capacidade), 1)
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(produto.operacao.name), 1)
                ]),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => ($setup.salvarVeiculo(produto)),
                      "onUpdate:modelValue": ($event: any) => ((produto.ativo) = $event)
                    }, null, 40, _hoisted_16), [
                      [_vModelCheckbox, produto.ativo]
                    ]),
                    _createElementVNode("label", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge badge-sm", {'bg-success': produto.ativo, 'bg-danger': !produto.ativo}])
                      }, _toDisplayString(produto.ativo ? 'Ativo' : 'Inativo'), 3)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => ($setup.getVeiculo(produto.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_21, 8, _hoisted_19),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => ($setup.getVeiculo(produto.id)),
                    class: "mx-3",
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Edit product"
                  }, _hoisted_24, 8, _hoisted_22),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => ($setup.getVeiculo(produto.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_27, 8, _hoisted_25)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}